import LinkIcon from '@mui/icons-material/Link';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useIntl } from '../../util/reactIntl';
import { ShareButtonBase } from './ShareButtonBase';
import { copyToClipboard, getFullURL } from './shareUtils';

export const CopyLinkButton = ({ url, onCopied, sharedItemName, shareOrigin, ...rest }) => {
  const intl = useIntl();
  const [isCopied, setIsCopied] = useState(false);
  const shareUrl = url || getFullURL();

  const handleCopy = () => {
    copyToClipboard(shareUrl)
      .then(() => {
        setIsCopied(true);
        if (onCopied) {
          onCopied();
        }
        setTimeout(() => {
          setIsCopied(false);
        }, 5000);
      })
      .catch(err => {
        console.error('Failed to copy URL: ', err);
      });
  };

  const copyLabel = isCopied
    ? intl.formatMessage({ id: 'ShareActions.copied', defaultMessage: 'Copied! Ready to paste!' })
    : intl.formatMessage({ id: 'ShareActions.copyLink', defaultMessage: 'Copy link' });

  return (
    <ShareButtonBase
      icon={<LinkIcon />}
      label={copyLabel}
      url={shareUrl}
      sharedItemName={sharedItemName}
      shareOrigin={shareOrigin}
      onClick={handleCopy}
      {...rest}
    />
  );
};

CopyLinkButton.propTypes = {
  url: PropTypes.string,
  onCopied: PropTypes.func,
};

CopyLinkButton.defaultProps = {
  url: '',
  onCopied: null,
};
